﻿export function onlyDigits(value) {
    return (value || "").replace(/\D/g, "");
}

export function setCaretPosition(el, pos) {
    if (!el) return;

    try {
        el.setSelectionRange(pos, pos);
    } catch (_) {
        // ignore
    }
}